const HolidayData = [
  {
    date: '2021-01-01',
    name: 'Tahun Baru'
  },
  {
    date: '2021-02-21',
    name: 'Tahun Baru Imlek'
  },
  {
    date: '2021-03-11',
    name: 'Isra Miraj Nabi Muhammad'
  },
  {
    date: '2021-03-14',
    name: 'Hari Raya Nyepi (Tahun Baru Saka)'
  },
  {
    date: '2021-04-2',
    name: 'Wafat Isa Almasih'
  },
  {
    date: '2021-05-01',
    name: 'Hari Buruh Internasional/Pekerja'
  },
  {
    date: '2021-05-12',
    name: 'Cuti Bersama Raya Idul Fitri 1442 Hijriah'
  },
  {
    date: '2021-05-13',
    name: 'Kenaikan Isa Al Masih'
  },
  {
    date: '2021-05-13',
    name: 'Hari Raya Idul Fitri 1442 Hijriyah'
  },
  {
    date: '2021-05-14',
    name: 'Hari Raya Idul Fitri 1442 Hijriyah'
  },
  {
    date: '2021-05-26',
    name: 'Hari Raya Waisak 2564'
  },
  {
    date: '2021-06-01',
    name: 'Hari Lahir Pancasila'
  },
  {
    date: '2021-07-20',
    name: 'Hari Raya Idul Adha 1442 Hijriyah'
  },
  {
    date: '2021-08-10',
    name: 'Tahun Baru Islam 1443 Hijriyah'
  },
  {
    date: '2021-08-17',
    name: 'Hari Kemerdekaan RI'
  },
  {
    date: '2021-10-19',
    name: 'Maulid Nabi Muhammad SAW'
  },
  {
    date: '2021-12-24',
    name: 'Cuti Bersama Hari Raya Natal'
  },
  {
    date: '2021-12-24',
    name: 'Cuti Bersama Hari Raya Natal'
  },
  {
    date: '2021-12-25',
    name: 'Hari Raya Natal'
  },
];

export default HolidayData;
